import React, {useEffect, useState} from "react";
import {onValue, push, ref, remove, set} from "firebase/database";
import { database } from "../../../utils/firebase";
import { useNavigate, useParams } from "react-router-dom";
import {
    Breadcrumbs,
    Dropdown,
    Link,
    ListDivider,
    ListItemDecorator,
    Menu,
    MenuButton,
    Typography,
    MenuItem,
    Button
} from "@mui/joy";
import DeleteForever from '@mui/icons-material/DeleteForever';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PrintIcon from '@mui/icons-material/Print';
import QuickReportGenerator from "../QuickReportGenerator/QuickReportGenerator";
import {Add, MoreVert} from "@mui/icons-material";

const App = () => {
    const { leagueId } = useParams();
    const navigate = useNavigate();
    const handicapRef = ref(database, `leagues/${leagueId}/handicaps`);
    const [handicapIds, setHandicapIds] = React.useState([]);
    const [handicapData, setHandicapData] = React.useState({});
    const leagueRef = ref(database, `leagues/${leagueId}`);
    const [leagueData, setLeagueData] = React.useState({});

    const [reportModalOpen, setReportModalOpen] = useState(false);
    const [reportType, setReportType] = useState('');
    const [reportId, setReportId] = useState('');

    useEffect(() => {
        onValue(handicapRef, (snapshot) => {
            const data = snapshot.val();
            setHandicapData(data);
            const ids = data ? Object.keys(data) : [];
            setHandicapIds(ids);
        });

        onValue(leagueRef, (snapshot) => {
            const data = snapshot.val();
            setLeagueData(data);
        });
    }, [leagueId]);

    const handleUnixTime = (unixTime) => {
        const date = new Date(unixTime * 1000);
        const options = {
            year: '2-digit',
            month: 'numeric',
            day: 'numeric',
            timeZone: leagueData.settings.timeZone
        };
        return date.toLocaleString(leagueData.settings.language, options);
    };

    const handleCreateNewHandicapSet = () => {
        const newHandicapSet = {
            name: 'New Handicap Set',
            startDate: Math.floor(Date.now() / 1000),
            endDate: Math.floor(Date.now() / 1000) + 2592000, // 30 days later
            flights: {},
            playerHandicaps: {}
        };
        push(handicapRef, newHandicapSet);
    };

    const handleCopyHandicapSet = (handicapId) => {
        const handicapSetToCopy = handicapData[handicapId];
        const newHandicapSet = {
            ...handicapSetToCopy,
            name: `${handicapSetToCopy.name} (Copy)`,
            playerHandicaps: handicapSetToCopy.playerHandicaps ? { ...handicapSetToCopy.playerHandicaps } : {}
        };
        push(handicapRef, newHandicapSet);
    };

    const handleDeleteHandicapSet = (handicapId) => {
        if (window.confirm("Are you sure you want to delete this handicap set?")) {
            remove(ref(database, `leagues/${leagueId}/handicaps/${handicapId}`));
        }
    };

    return (
        <div>
            <div className="container">
                <Breadcrumbs aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" onClick={() => navigate(`/app/league/${leagueId}/dashboard`)}>
                        {leagueData.name}
                    </Link>
                    <Typography sx={{ color: 'text.primary' }}>Handicaps</Typography>
                </Breadcrumbs>
                <h1>Handicaps</h1>
                <div className="dashboard">
                    <div className="ldb-matches-list">
                        {handicapIds.map((handicapId) => (
                            <div className="ldb-match" key={handicapId}>
                                {handicapData[handicapId].name} ({handleUnixTime(handicapData[handicapId].startDate)} - {handleUnixTime(handicapData[handicapId].endDate)})
                                <div className="dash-league-item-buttons">
                                    <Button className={'button-gradient'} onClick={() => navigate(`/app/league/${leagueId}/handicap/${handicapId}`)}>Open</Button>
                                    <Dropdown>
                                        <MenuButton variant={"plain"} sx={{width: "15px"}}>
                                            <MoreVert/>
                                        </MenuButton>
                                        <Menu placement="bottom-end">
                                            <MenuItem onClick={
                                                () => {
                                                    setReportModalOpen(true);
                                                    setReportType('handicapReport');
                                                    setReportId(handicapId);
                                                }}>
                                                <ListItemDecorator sx={{color: 'inherit'}}><PrintIcon/></ListItemDecorator>{" "}
                                                Handicap Report
                                            </MenuItem>
                                            <ListDivider />
                                            <MenuItem onClick={() => handleCopyHandicapSet(handicapId)}>
                                                <ListItemDecorator sx={{color: 'inherit'}}><ContentCopyIcon/></ListItemDecorator>{" "}
                                                Duplicate
                                            </MenuItem>
                                            <MenuItem variant="soft" color="danger" onClick={() => handleDeleteHandicapSet(handicapId)}>
                                                <ListItemDecorator sx={{ color: 'inherit'}}><DeleteForever/></ListItemDecorator>{" "}
                                                Delete
                                            </MenuItem>
                                        </Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        ))}
                    </div>
                    <Button className={'button-gradient'} onClick={handleCreateNewHandicapSet} startDecorator={<Add/>}>Create New Handicap Set</Button>
                </div>
            </div>
            <QuickReportGenerator
                type={reportType}
                id={reportId}
                modalOpen={reportModalOpen}
                closeModal={() => setReportModalOpen(false)}
                leagueId={leagueId}
            />
        </div>
    );
};

export default App;